import { useRef } from 'react';
import type { MeResponse } from '../api';
import { AssistantBar } from './AssistantBar';
import { ActivityLog, type ActivityLogHandle } from './ActivityLog';

/**
 * Typed and spoken log editing.
 *
 * Both go to the same endpoint family and the same assistant. When a turn came from speech,
 * the transcript is shown above the reply: if the assistant does something unexpected, the
 * cause is nearly always a misheard word, and seeing what was heard turns a baffling result
 * into an obvious one.
 */
export function AssistantView({ me }: { me: MeResponse }) {
  const activity = useRef<ActivityLogHandle>(null);

  return (
    <>
      <div className="panel">
        <h2>Tell it what happened</h2>
        <p className="sub">
          Say it the way you would to a person: “we spent an hour from 2 to 3 talking about
          vegetables in the garden”. It will ask rather than guess if you leave out when
          something happened, or whether you were at home.
        </p>
        <AssistantBar me={me} onDone={() => activity.current?.reload()} />
      </div>

      <ActivityLog ref={activity} me={me} limit={25} onChanged={() => { void 0; }} />

    </>
  );
}
